<div class="m-4">
    <form #f="ngForm" [formGroup]="creatingUserForm">
        <div class="row boder-dashed">
            <div class="col-12 px-0">
                <div class="row" class="font-weight-bold mb-4">
                    <div class="col-12 px-0">
                        Default Roles
                    </div>
                </div>
                <div class="row">
                    <div class="col-4 px-0">
                        <label >Role Type*</label>
                        <div class="row w-100"> 
                            <p-multiSelect [options]="listRoles" class="w-100" optionDisabled="inactive"
                                formControlName="rollType" defaultLabel="Select" optionLabel="name" (click)="selectedRoles()"
                                optionValue="roleId"  name="rollType">
                            </p-multiSelect>
                        </div>    
                    </div>
                </div>
            </div>
        </div>
    </form>

    <div class="row mt-4 mb-4">
        <div class="col-12 px-0">
            <p class="text-danger" *ngIf="roleDataSource.length == 0">No user added to list yet</p>
        </div>
        <div class="col-12 px-0">
            <p-table [columns]="origColumns" [value]="roleDataSource" [scrollable]="true"  scrollHeight="400px" scrollDirection="both">
                <ng-template pTemplate="header">
                  <tr>
                    <th>Permission</th>
                    <th *ngFor="let col of origColumns" class="text-center">
                      {{col.columnDef}}
                  </th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-doc let-columns="columns">
                  <tr>
                    <td>
                    <span>
                      {{ doc.perm_name}}
                    </span>
                  </td>
                  <td *ngFor="let col of columns" class="text-center">
                    <div class="text-center width-100">
                    <div [class.green_tick]="doc[col.columnDef] == true" class="perm_box"
                      [class.grey_cross]="doc[col.columnDef] == false">
                      <i class="pi pi-check" *ngIf="doc[col.columnDef] == true"></i>
                      <i class="pi pi-times" *ngIf="doc[col.columnDef] == false"></i>
                    </div>
                  </div>
                  </td>
                  
                  </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                  <tr>
                      <td colspan="12">No Data</td>
                  </tr>
              </ng-template>
              </p-table>
        </div>
    </div>

    <div class="row">
      <div class="col-6"></div>
      <div class="col text-right">
        <button (click)="onCancel()" pButton type="button" class="align-top mr-4 p-button-secondary">
          Cancel
        </button>

        <div class="border-right d-inline-block mr-4" style="height:46px"></div>
        <button (click)="onPrevious()" class="im-btn im-btn-primary im-btn-md" [disabled]="">
          Previous
        </button>
        <button (click)="creatingUserFormSub()" class="im-btn im-btn-primary im-btn-md mx-2" [disabled]="disableFields">
          Save
        </button>
        <button (click)="onNext()" class="im-btn im-btn-primary im-btn-md" [disabled]="">
          Next
        </button>

      </div>
    </div>
</div>

<p-confirmDialog header="Delete"></p-confirmDialog>